function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "2i9nottfna",
  d: "M0 0h10v10H0z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "xek7b55lrb",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#2i9nottfna"
})), /*#__PURE__*/React.createElement("path", {
  d: "M6.066 5 9.78 1.287A.754.754 0 0 0 8.713.22L5 3.934 1.287.22A.754.754 0 0 0 .221 1.287L3.934 5 .22 8.713A.754.754 0 0 0 1.287 9.78L5 6.066 8.713 9.78a.75.75 0 0 0 1.067 0 .754.754 0 0 0 0-1.066L6.066 5",
  fill: "#DA4D4D",
  mask: "url(#xek7b55lrb)"
}));

var SvgRedCross = function SvgRedCross(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRedCross, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/red-cross.d1cc3758.svg";
export { ForwardRef as ReactComponent };